import React from 'react';
import { ChevronDown, ChevronUp, ArrowRight } from 'lucide-react';
import IconSelector from '../common/IconSelector';
import StatusBadge from '../common/StatusBadge';
import PriorityBadge from '../common/PriorityBadge';

const TriggerCard = ({ trigger, isExpanded, onToggle }) => {
  return (
    <div className="border rounded-lg overflow-hidden">
      <div
        className={`p-4 cursor-pointer flex justify-between items-center ${
          trigger.priority === "High" ? 'bg-red-50' : 
          trigger.priority === "Medium" ? 'bg-yellow-50' : 
          'bg-blue-50'
        }`}
        onClick={() => onToggle(trigger.id)}
      >
        <div className="flex-grow">
          <div className="flex items-center">
            <span className="flex items-center mr-2">
              <IconSelector type={trigger.type} />
            </span>
            <span className="text-sm font-medium text-gray-900">{trigger.title}</span>
            <span className="ml-3">
              <StatusBadge status={trigger.status} />
            </span>
          </div>
          <div className="text-xs text-gray-500 mt-1 flex items-center">
            <span>{trigger.type}</span>
            <span className="mx-2">•</span>
            <span>Detected on {trigger.date}</span>
          </div>
        </div>
        <div className="flex items-center">
          <span className="mr-3">
            <PriorityBadge priority={trigger.priority} />
          </span>
          {isExpanded ? <ChevronUp size={18} className="text-gray-500" /> : <ChevronDown size={18} className="text-gray-500" />}
        </div>
      </div>
      
      {isExpanded && (
        <div className="p-4 bg-white border-t border-gray-100">
          <p className="text-sm text-gray-600 mb-4">{trigger.description}</p>
          <h4 className="text-sm font-medium text-gray-700 mb-2">Suggested Actions:</h4>
          <ul className="list-none space-y-2 mb-4">
            {trigger.suggestedActions.map((action, index) => (
              <li key={index} className="flex items-start text-sm">
                <ArrowRight size={16} className="text-primary mr-2 flex-shrink-0 mt-0.5" />
                <span>{action}</span>
              </li>
            ))}
          </ul>
          <div className="flex justify-between mt-4">
            <button className="px-3 py-1.5 bg-white border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50">
              Dismiss
            </button>
            <button className="px-3 py-1.5 bg-blue-600 rounded-md text-sm font-medium text-white hover:bg-blue-700">
              Create Conversation
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TriggerCard;